module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav"
  }, [_c('ul', {
    staticClass: "nav_list"
  }, [_c('li', {
    staticClass: "nav_item"
  }, [_c('router-link', {
    staticClass: "nav_link",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _c('li', {
    staticClass: "nav_item"
  }, [_c('router-link', {
    staticClass: "nav_link",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About")])], 1), _c('li', {
    staticClass: "nav_item"
  }, [_c('router-link', {
    staticClass: "nav_link",
    attrs: {
      "to": "/works"
    }
  }, [_vm._v("Works")])], 1), _c('li', {
    staticClass: "nav_item"
  }, [_c('router-link', {
    staticClass: "nav_link",
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Contact")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f796332","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/NavHeader.vue
// module id = 38
// module chunks = 0